import { render } from "./SelectImportType.vue?vue&type=template&id=7565d6f9"
import script from "./SelectImportType.vue?vue&type=script&lang=js"
export * from "./SelectImportType.vue?vue&type=script&lang=js"
script.render = render

export default script